import React, { useEffect, useState } from "react";
import { isAuthenticated, fetchMe, logout } from "../services/adminApi";
import LoginPage from "./LoginPage";
import AdminDashboard from "./AdminDashboard";
import "./admin.css";

const AdminApp = () => {
    const [status, setStatus] = useState("checking"); // checking | guest | authed

    useEffect(() => {
        if (!isAuthenticated()) {
            setStatus("guest");
            return;
        }
        fetchMe()
            .then(() => setStatus("authed"))
            .catch(() => setStatus("guest"));
    }, []);

    const handleLoggedIn = () => setStatus("authed");
    const handleLogout = () => {
        logout();
        setStatus("guest");
    };

    if (status === "checking") {
        return <div className="admin-boot-screen">Загрузка…</div>;
    }

    if (status === "guest") {
        return <LoginPage onLoggedIn={handleLoggedIn} />;
    }

    return <AdminDashboard onLogout={handleLogout} />;
};

export default AdminApp;
